import { registerLocaleData } from '@angular/common';
import bg from '@angular/common/locales/bg';
import cs from '@angular/common/locales/cs';
import da from '@angular/common/locales/da';
import de from '@angular/common/locales/de';
import deAT from '@angular/common/locales/de-AT';
import deCH from '@angular/common/locales/de-CH';
import deLU from '@angular/common/locales/de-LU';
import en from '@angular/common/locales/en';
import es from '@angular/common/locales/es';
import et from '@angular/common/locales/et';
import fi from '@angular/common/locales/fi';
import fr from '@angular/common/locales/fr';
import frBE from '@angular/common/locales/fr-BE';
import frCH from '@angular/common/locales/fr-CH';
import hr from '@angular/common/locales/hr';
import hu from '@angular/common/locales/hu';
import it from '@angular/common/locales/it';
import lt from '@angular/common/locales/lt';
import lv from '@angular/common/locales/lv';
import nl from '@angular/common/locales/nl';
import nlBE from '@angular/common/locales/nl-BE';
import pl from '@angular/common/locales/pl';
import pt from '@angular/common/locales/pt';
import ro from '@angular/common/locales/ro';
import ru from '@angular/common/locales/ru';
import sk from '@angular/common/locales/sk';
import sl from '@angular/common/locales/sl';
import sr from '@angular/common/locales/sr';
import sv from '@angular/common/locales/sv';
import no from '@angular/common/locales/no';
import nb from '@angular/common/locales/nb';
import nn from '@angular/common/locales/nn';
import tr from '@angular/common/locales/tr';
import uk from '@angular/common/locales/uk';
import zh from '@angular/common/locales/zh';
import { TranslateService } from '@ngx-translate/core';

import { SUPPORTED_LOCALES } from '@store';

export class DynamicLocaleId extends String {
  constructor(protected service: TranslateService) {
    super('');

    registerLocaleData(bg, SUPPORTED_LOCALES.bg);
    registerLocaleData(cs, SUPPORTED_LOCALES.cs);
    registerLocaleData(da, SUPPORTED_LOCALES.da);
    registerLocaleData(de, SUPPORTED_LOCALES.de);
    registerLocaleData(deAT, 'de-AT');
    registerLocaleData(deCH, 'de-CH');
    registerLocaleData(deLU, 'de-LU');
    registerLocaleData(en, SUPPORTED_LOCALES.en);
    registerLocaleData(es, SUPPORTED_LOCALES.es);
    registerLocaleData(et, SUPPORTED_LOCALES.et);
    registerLocaleData(fi, SUPPORTED_LOCALES.fi);
    registerLocaleData(fr, SUPPORTED_LOCALES.fr);
    registerLocaleData(frBE, 'fr-BE');
    registerLocaleData(frCH, 'fr-CH');
    registerLocaleData(hr, SUPPORTED_LOCALES.hr);
    registerLocaleData(hu, SUPPORTED_LOCALES.hu);
    registerLocaleData(it, SUPPORTED_LOCALES.it);
    registerLocaleData(lt, SUPPORTED_LOCALES.lt);
    registerLocaleData(lv, SUPPORTED_LOCALES.lv);
    registerLocaleData(nl, SUPPORTED_LOCALES.nl);
    registerLocaleData(nlBE, 'nl-BE');
    registerLocaleData(nb, SUPPORTED_LOCALES.nb);
    registerLocaleData(no, SUPPORTED_LOCALES.no);
    registerLocaleData(nn, SUPPORTED_LOCALES.nn);
    registerLocaleData(pl, SUPPORTED_LOCALES.pl);
    registerLocaleData(pt, SUPPORTED_LOCALES.pt);
    registerLocaleData(ro, SUPPORTED_LOCALES.ro);
    registerLocaleData(ru, SUPPORTED_LOCALES.ru);
    registerLocaleData(sk, SUPPORTED_LOCALES.sk);
    registerLocaleData(sl, SUPPORTED_LOCALES.sl);
    registerLocaleData(sr, SUPPORTED_LOCALES.sr);
    registerLocaleData(sv, SUPPORTED_LOCALES.sv);
    registerLocaleData(tr, SUPPORTED_LOCALES.tr);
    registerLocaleData(uk, SUPPORTED_LOCALES.uk);
    registerLocaleData(zh, 'zh-CN');
  }

  toString(): string {
    return this.service.currentLang;
  }
}
